import { sendDelete, sendGet, sendPost } from "./axios";

export const getEventImage = () => sendGet("/event-images");
export const uploadEventImage = (params) => sendPost("/event-images", params);
export const deleteEventImage = (id) => sendDelete(`/event-images`);
